import { products, users, dailyDiscussion, researchArticles, strains, growJournals,userProfiles } from '../data/data';
import React from 'react';
export function GrowJournalDetailPage({ journalId }) {
  const journal = growJournals.find((j) => j.id === Number.parseInt(journalId))

  if (!journal) {
    return <div>Journal not found</div>
  }

  const author = userProfiles.find((p) => p.slug === journal.authorSlug)
  const strain = strains.find((s) => s.name === journal.strainName)

  return (
    <div style={{ maxWidth: '1000px', margin: '0 auto', padding: '48px 16px' }}>
      {/* Header */}
      <div style={{ marginBottom: '32px' }}>
        <h1 style={{
          fontSize: '48px',
          fontWeight: '800',
          letterSpacing: '-0.025em',
          margin: 0
        }}>
          {journal.title}
        </h1>
        <div style={{
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'center',
          gap: '24px 24px',
          marginTop: '16px',
          color: '#6b7280'
        }}>
          <div 
            onClick={() => console.log(`Navigate to profile: ${author?.slug}`)}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              cursor: 'pointer',
              color: '#2563eb'
            }}
          >
            <div style={{
              width: '24px',
              height: '24px',
              borderRadius: '50%',
              overflow: 'hidden'
            }}>
              <img 
                src={author?.avatar || "/placeholder.svg"} 
                alt={author?.name}
                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              />
            </div>
            <span style={{ fontWeight: '600' }}>{author?.name}</span>
          </div>
          <div 
            onClick={() => console.log(`Navigate to strain: ${strain?.slug}`)}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              cursor: 'pointer',
              color: '#2563eb'
            }}
          >
            🌱
            <span style={{ fontWeight: '600' }}>{journal.strainName}</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            📅
            <span>Started {journal.startDate}</span>
          </div>
        </div>
      </div>

      {/* Timeline */}
      <div style={{ position: 'relative', paddingLeft: '32px' }}>
        <div style={{
          position: 'absolute',
          left: '32px',
          top: 0,
          bottom: 0,
          width: '2px',
          backgroundColor: '#e5e7eb'
        }} />
        {journal.entries.map((entry, index) => (
          <div key={entry.id} style={{ position: 'relative', marginBottom: '48px' }}>
            <div style={{
              position: 'absolute',
              left: '-44px',
              top: '6px',
              width: '24px',
              height: '24px',
              backgroundColor: '#2563eb',
              borderRadius: '50%',
              border: '4px solid white'
            }} />
            <p style={{ fontSize: '14px', color: '#6b7280', marginBottom: '4px', margin: '0 0 4px 0' }}>{entry.date}</p>
            <h2 style={{
              fontSize: '24px',
              fontWeight: 'bold',
              margin: '0 0 16px 0'
            }}>
              Week {entry.week}: {entry.title}
            </h2>
            <div style={{
              display: 'grid',
              gridTemplateColumns: '2fr 1fr',
              gap: '24px',
              marginTop: '16px'
            }}>
              <div>
                <p style={{ color: '#374151', lineHeight: '1.6', margin: 0 }}>{entry.notes}</p>
              </div>
              <div>
                <img
                  src={entry.image || "/placeholder.svg"}
                  alt={entry.title}
                  style={{
                    width: '100%',
                    height: '100%',
                    borderRadius: '8px',
                    objectFit: 'cover',
                    aspectRatio: '1'
                  }}
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}